import { Accepts, Types } from "@citychallenge/common";
import { Inlet, Outlet } from "../../reactive";
import { defineElement } from "../define-element";

export class MapProps {
  @Inlet(Accepts.MarkdownText) public text?: Types["MarkdownText"];

  // Note: Added in 0.12.0. So assume empty.
  @Inlet(Accepts.GeoCamera) public camera?: Types["GeoCamera"];
  @Inlet(Accepts.GeoMarkerList) public markers!: Types["GeoMarkerList"];

  @Inlet(Accepts.Boolean) public disableUserTracking?: Types["Boolean"];
  @Inlet(Accepts.Boolean) public allowSkip?: Types["Boolean"];

  @Inlet(Accepts.String) public styleURL?: Types["String"];

  @Inlet(Accepts.Image) public customAvatar?: Types["Image"];
  @Inlet(Accepts.Scale) public customAvatarScale?: Types["Scale"];

  /* Distance from marker action */
  @Outlet({
    arguments: {
      // Accepts number
      distance: Accepts.Number,
      marker: {
        type: Accepts.GeoMarker,
        // When validating agianst a List inlet, the List inlet MUST have a
        // property with an 'id' subkey if it is an object. Otherwise it defaults to
        // a plain value comparison
        inlet: "markers",
      },
    },
  })
  public distanceFromMarker?: (value: {
    distance: Types["Number"];
    marker: Types["GeoMarker"];
  }) => void;

  /* Distance from marker action */
  @Outlet({
    arguments: {
      // Accepts number
      marker: {
        type: Accepts.GeoMarker,
        // When validating agianst a List inlet, the List inlet MUST have a
        // property with an 'id' subkey if it is an object. Otherwise it defaults to
        // a plain value comparison
        inlet: "markers",
      },
    },
  })
  public tapOnMarker?: (value: { marker: Types["GeoMarker"] }) => void;
}

export const MapDefinition = defineElement("map", MapProps, {
  versionRequired: "0.8.0",
});
